<template>
	<div class="mapping-container">
		<div class="accordion" id="accordionPanelsStayOpenExample">
			<div class="content-wrap">
				<div class="table-responsive table-cf">
					<div class="tab-header-wrapper">
						<TabView :activeIndex="state.activeIndex" @update:activeIndex="state.activeIndex = $event">
							<TabPanel header="상품맵핑">
								<Splitter class="mb-5">
									<SplitterPanel class="flex align-items-start justify-content-center">
										<Panel class="w-full">
											<template #header>
												<div class="panel-header-container">
													<h2 class="panel-title">{{ state.revSelect.selected || '전체' }} 상품</h2>
													<ElSelect
														v-if="!isMappingInProgress"
														v-model="state.revSelect.selected"
														:options="state.revSelect.list"
														placeholder="버전 선택"
														teleported 
														class="rev-select"
													/>
												</div>
											</template>
											<DataTable
												:value="state.version1Data"
												selectionMode="multiple"
												v-model:selection="selectedVersion1Item"
												dataKey="class_Id"
												:rowClass="rowClassV1"
												:rowSelectable="isRowSelectableV1"
												@row-click="onRowClickV1"
												:metaKeySelection="false"
												class="p-datatable-sm" >
												<template #empty>
													<div class="center">데이터가 존재하지 않습니다.</div>
												</template>
												<Column v-if="state.version1Data.length > 0" field="class_nm" header="상품명"/>
											</DataTable>
										</Panel>
									</SplitterPanel>
									<SplitterPanel class="flex align-items-start justify-content-center">
										<Panel class="w-full">
											<template #header>
												<div class="panel-header-container">
													<h2 class="panel-title">{{ state.revSelect2.selected || '전체' }} 상품</h2>
													<ElSelect
														v-if="!isMappingInProgress"
														v-model="state.revSelect2.selected"
														:options="state.revSelect.list"
														placeholder="버전 선택" 
														class="rev-select"
													/>
												</div>
											</template>
											<DataTable 
												:value="state.version2Data" 
												selectionMode="multiple" 
												v-model:selection="selectedVersion2Item"
												:rowClass="rowClassV2"
												:rowSelectable="isRowSelectableV2" 
												@row-click="onRowClickV2"
												class="p-datatable-sm" 
												>
												<template #empty>
													<div class="center">데이터가 존재하지 않습니다.</div>
												</template>
												<Column v-if="state.version2Data.length > 0" field="class_nm" header="상품명"/>
											</DataTable>
										</Panel>
									</SplitterPanel>
								</Splitter>
								
							</TabPanel>
							
							<TabPanel header="결과">
								<h2>임시 매핑 결과 ({{ state.revSelect.selected || '전체' }} <> {{ state.revSelect2.selected || '전체' }})</h2>
								<table class="result-table">
									<thead>
										<tr>
											<th colspan="1">{{ state.revSelect.selected || '전체' }} 상품</th>
											<th></th>
											<th colspan="1">{{ state.revSelect2.selected || '전체' }} 상품</th>
										</tr>
									</thead>
									<tbody>
										<template v-for="(item, itemIndex) in mappedItems" :key="itemIndex">
											<tr v-for="(child, childIndex) in item.children" :key="childIndex" @click="confirm1(item, $event)" class="cursor-pointer">
												<td v-if="childIndex === 0" :rowspan="item.children.length">{{ item.parent.class_nm }}</td>
												<td class="arrow"></td>
												<td>{{ child.class_nm }}</td>
											</tr>
										</template>
										<tr v-if="mappedItems.length === 0">
											<td colspan="3" class="text-center py-4">매핑된 항목이 없습니다.</td>
										</tr>
									</tbody>
								</table>
								<div class="text-end py-2">
									<Button
										label="매핑 결과 저장"
										icon="pi pi-save"
										@click="mappingProdList"
										class="p-button-primary"
										style="width: auto;"
									/>
								</div>
							</TabPanel>

							<TabPanel header="저장된 매핑">
								<div class="panel-header-container">
									<h2>저장된 매핑 내역</h2>
									<div class="mb-3">
									<ElLabel name="상품 버전 아이디">
										<template #end="{id}">
											<ElSelect
											v-model="state.revSelect3.selected"
											:options="state.revSelect.list"
											placeholder="버전 선택" 
											class="rev-select"
											/>
										</template>
									</ElLabel>
									</div>
									
								</div>
								<table class="result-table">
									<thead>
										<tr>
											<th style="width: 30px;">
												
												<ElCheckbox 
													:modelValue="selectedSavedParentIds.size > 0 && isAllSavedParentsSelected" 
													:binary="true"
													:disabled="savedMappings.length === 0"
													:indeterminate="isParentSavedSelected.indeterminate"
													@change="toggleAllSavedSelection"
												/>
											</th>
											<th colspan="1">{{ savedMappingsV1RevId }} 상품</th>
											<th colspan="1">{{ savedMappingsV2RevId }} 상품</th>
										</tr>
									</thead>
									<tbody>
										<template v-if="savedMappings.length > 0" v-for="(item, itemIndex) in savedMappings" :key="itemIndex">
											<tr v-for="(child, childIndex) in item.children" :key="childIndex">
												<td style="width: 30px; text-align: center;vertical-align: middle;" v-if="childIndex === 0" :rowspan="item.children.length">
													<ElCheckbox 
														:modelValue="selectedSavedParentIds.has(item.parent.class_Id)" 
														:binary="true" 
														@change="toggleSavedParentSelection(item.parent.class_Id)"
													/>
												</td>
												
												<td v-if="childIndex === 0" :rowspan="item.children.length">{{ item.parent.class_nm }}</td>

												<td>{{ child.class_nm || '(매핑 없음)' }}</td>
											</tr>
										</template>
										<tr v-else>
											<td colspan="3" class="text-center py-4">저장된 매핑 데이터가 없습니다. (버전을 선택해 주세요.)</td>
										</tr>
									</tbody>
								</table>
								
								<div class="text-end py-2">
									<Button
									class="btn btn-danger btn-lg me-3"
										label="맵핑 해제"
										icon="pi pi-times"
										@click="getSelectedData"
										:disabled="selectedSavedParentIds.size === 0"
									/>
								</div>
							</TabPanel>
							
						</TabView><Button
							label="매핑 실행"
							icon="pi pi-link"
							@click="mapItems"
							:disabled="!selectedVersion1Item.length || !selectedVersion2Item.length"
							class="p-button-sm p-button-success mapping-execute-btn-final-absolute"
						/>
					</div>
					
				</div>
			</div>
			
		</div>
		<ConfirmPopup></ConfirmPopup>
		<Toast position="top-center" />
	</div>
</template>
 
<script setup>
import { ref ,onMounted, reactive,computed,watch} from 'vue';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Panel from 'primevue/panel';
import { depthProdList ,getProdRevIdList,mappingProd,getMappingProdList, deleteMappingProd} from "@/api/prod"; 
import { useConfirm } from "primevue/useconfirm";
import { useToast } from "primevue/usetoast";
import Toast from 'primevue/toast'
import ConfirmPopup from 'primevue/confirmpopup';

const confirm = useConfirm();
const toast = useToast();


const confirm1 = (item,event) => {
  confirm.require({
  target: event.currentTarget,
  message: `${item.parent.class_nm} 상품의 매핑을 제거하고 다시 맵핑하시겠습니까?`,
  icon: 'pi pi-exclamation-triangle',
  rejectClass: 'p-button-secondary p-button-outlined p-button-sm',
  acceptClass: 'p-button-sm',
  acceptLabel: '확인',
  rejectLabel: '취소',
  accept: () => {
    removeRow(item.parent.class_Id)
  },
  reject: () => {
    toast.add({ severity: 'error', summary: '취소', detail: '매핑 제거가 취소되었습니다.', life: 3000 });
  }
  });
};

const selectedVersion1Item = ref([]);
const selectedVersion2Item = ref([]);
const mappings = ref({}); 
const mappedVersion1Ids = ref(new Set());
const mappedVersion2Ids = ref(new Set());
const savedMappings = ref([]); 
const savedMappingsV1RevId = ref(); 
const savedMappingsV2RevId = ref();
const selectedSavedParentIds = ref(new Set()); 

const state = reactive({
  maxRevid:'',
  version1Data : [],
  version2Data : [],
  revidList:'',
  activeIndex: 0, 
  revSelect: {
    selected: "",
    list: [],
  },
  revSelect2: {
    selected: "",
    list: [],
  },
  revSelect3: {
    selected: "",
    list: [],
  }
})

onMounted(async () => {
  await getProdYearLists();
  await getList();
  await getList2();
});

const isAllSavedParentsSelected = computed(() => {
  if (savedMappings.value.length === 0) return false;
  return selectedSavedParentIds.value.size === savedMappings.value.length;
});

const isParentSavedSelected = computed(() => {
  const total = savedMappings.value.length;
  const selected = selectedSavedParentIds.value.size;
  return {
    selected: selected > 0,
    indeterminate: selected > 0 && selected < total
  };
});

const toggleSavedParentSelection = (classId) => {
  if (selectedSavedParentIds.value.has(classId)) {
    selectedSavedParentIds.value.delete(classId);
  } else {
    selectedSavedParentIds.value.add(classId);
  }
  selectedSavedParentIds.value = new Set(selectedSavedParentIds.value);
};

const toggleAllSavedSelection = () => {
  if (isAllSavedParentsSelected.value) {
    selectedSavedParentIds.value.clear();
  } else {
    savedMappings.value.forEach(item => {
      selectedSavedParentIds.value.add(item.parent.class_Id);
    });
  }
  selectedSavedParentIds.value = new Set(selectedSavedParentIds.value);
};


const mapItems = () => {
  if (!selectedVersion1Item.value.length || !selectedVersion2Item.value.length) {
  toast.add({ severity: 'warn', summary: '선택 필요', detail: '버전 1과 버전 2에서 각각 하나 이상의 항목을 선택해야 합니다.', life: 3000 });
  return;
  }

  selectedVersion1Item.value.forEach((v1Item) => {
    mappedVersion1Ids.value.add(v1Item.class_Id);
    
    const childrenData = selectedVersion2Item.value.map((v2Item) => {
    mappedVersion2Ids.value.add(v2Item.class_Id); 
    return {
      class_nm: v2Item.class_nm,
      class_id: v2Item.class_Id,
    };
    });
  
    mappings.value[v1Item.class_nm] = {
      parent_class_id: v1Item.class_Id,
      children: childrenData,
    };
  });

  selectedVersion1Item.value = [];
  selectedVersion2Item.value = [];
};

const mappedItems = computed(() => {
const result = [];
Object.keys(mappings.value).forEach((parent_class_nm) => {
  const mappingEntry = mappings.value[parent_class_nm];
  
  result.push({
  parent: {
   'class_nm': parent_class_nm,
   'class_Id': mappingEntry.parent_class_id
  },
  children: mappingEntry.children.length > 0 ? mappingEntry.children : [{ class_nm: '(매핑 없음)', class_id: null }], 
  });
});
return result;
});


const getProdYearLists = async () =>{
try {
  const res = await getProdRevIdList(); 
  const revisions = res.rtn || []; 
  const allOption = { text: '선택해주세요.', value: '' };

  
  const mappedRevisions = revisions.map(item => ({
  text: item.rev_id, 
  value: item.rev_id 
  }));
  const finalList = [allOption, ...mappedRevisions];
  state.revSelect.list = finalList;
  state.revSelect2.list = finalList; 
   state.revSelect3.list = finalList; 

  state.revSelect.selected = allOption.value; 
  state.revSelect2.selected = allOption.value; 
   state.revSelect3.selected = allOption.value; 

} catch (err) {
  console.error("Error fetching revision lists:", err)
  toast.add({ severity: 'error', summary: '오류', detail: '버전 목록을 불러오는 데 실패했습니다.', life: 3000 });
} 
}

watch(
() => state.revSelect.selected,
(newVal) => {
   if(state.revSelect2.selected && state.revSelect.selected === state.revSelect2.selected){
     toast.add({ severity: 'info', summary: '알림', detail: `같은 상품아이디로 맵핑할수 없습니다. 다시선택해 주세요.`, life: 3000 });
     state.revSelect.selected=''
     return
   }
  if(state.revSelect2.selected && state.revSelect.selected){
        const IS_FORWARD_MAPPING = true; 
        if (!checkSwappedRule(state.revSelect.selected, state.revSelect2.selected, state.revSelect.list, IS_FORWARD_MAPPING)) {
            
            const numA = parsePVString(state.revSelect.selected);
            const numB = parsePVString(state.revSelect2.selected);
            
            let errorMessage = ``;

            if (numA > numB) {
                errorMessage = `${state.revSelect2.selected} 상품보다 더 낮은 버전으로만 맵핑할 수 있습니다.`;
            } else {
                errorMessage = `${state.revSelect2.selected} 상품보다 **1단계 차이**의 버전으로만 맵핑할 수 있습니다.`;
            }

            toast.add({ severity: 'error', summary: '알림', detail: errorMessage, life: 3000 });
            state.revSelect.selected=''
            return
        }
    }
   getList(); 
})

watch(
() => state.revSelect2.selected,
(newVal) => {
   if(state.revSelect.selected && state.revSelect.selected === state.revSelect2.selected){
     toast.add({ severity: 'info', summary: '알림', detail: `같은 상품아이디로 맵핑할수 없습니다. 다시선택해 주세요.`, life: 3000 });
     state.revSelect2.selected=''
     return
   }
   if(state.revSelect2.selected && state.revSelect.selected){
        const IS_FORWARD_MAPPING = true; 
        if (!checkSwappedRule(state.revSelect.selected, state.revSelect2.selected, state.revSelect.list, IS_FORWARD_MAPPING)) {
            
            const numA = parsePVString(state.revSelect.selected);
            const numB = parsePVString(state.revSelect2.selected);
            
            let errorMessage = ``;

            if (numA > numB) {
                errorMessage = `${state.revSelect.selected} 상품보다 더 높은 버전으로만 맵핑할 수 있습니다.`;
            } else {
                errorMessage = `${state.revSelect.selected} 상품보다 1단계 차이의 버전으로만 맵핑할 수 있습니다.`;
            }

            toast.add({ severity: 'error', summary: '알림', detail: errorMessage, life: 3000 });
            state.revSelect2.selected=''
            return
        }
    }
  getList2();
})

watch(
   () => state.revSelect3.selected,
   (newVal) => {
   getSavedMappingsList(); 
     selectedSavedParentIds.value.clear(); 
   }
)

const checkSwappedRule = (a, b, fullList, isLeft) => {

    const numA = parsePVString(a);
    const numB = parsePVString(b);

    if (isLeft) {
        if (numA >= numB) {
            return false;
        }
    } else {
      
        if (numB >= numA) { 
            return false;
        }
    }

    const numericList = fullList
        .filter(item => item && item.value && item.value !== '') 
        .map(item => parsePVString(item.value));

    const standardValue = Math.max(numA, numB); 
    const compareValue = Math.min(numA, numB);  

    const smallerThanStandard = numericList.filter(x => x < standardValue);

    if (smallerThanStandard.length === 0) {
        return false;
    }

    const smallestOfSmaller = Math.max(...smallerThanStandard);
    
    return smallestOfSmaller === compareValue;
};

const parsePVString = (pvString) => {
    if (typeof pvString !== 'string' || pvString === '') {
        return 0; 
    }
    const numericPart = pvString.replace(/^PV/, '');
    const num = parseInt(numericPart, 10);
    return isNaN(num) ? 0 : num; 
};

const isMappingInProgress = computed(() => {
return Object.keys(mappings.value).length > 0;
});

const removeRow = (parentClassId) => {
  const parentClassNm = Object.keys(mappings.value).find(
  (key) => mappings.value[key].parent_class_id === parentClassId
  );

if (parentClassNm) {

  const childrenToRemove = mappings.value[parentClassNm].children;

  delete mappings.value[parentClassNm];

  mappedVersion1Ids.value.delete(parentClassId);

  childrenToRemove.forEach(child => {
  if (child.class_id) { 
   mappedVersion2Ids.value.delete(child.class_id);
  }
  });

  toast.add({ severity: 'info', summary: '매핑 제거됨', detail: `${parentClassNm} 매핑이 제거되었습니다. 다시 매핑할 수 있습니다.`, life: 3000 });
} else {
  toast.add({ severity: 'error', summary: '오류', detail: '제거할 매핑을 찾을 수 없습니다.', life: 3000 });
}
};

const getList = async () => {
  let params = {
  rev_id: state.revSelect.selected, 
  };
  try {
  const res = await depthProdList(params) 
  state.version1Data = [...res.rtn]
  } catch (err) {
  console.error("Error fetching list 1:", err)
  } 
};

const getList2 = async () => {
  let params = {
  rev_id: state.revSelect2.selected,
  };
  try {
  const res = await depthProdList(params) 
  state.version2Data = [...res.rtn]
  } catch (err) {
  console.error("Error fetching list 2:", err)
  } 
};

const getSavedMappingsList = async () => {
  const res = await getMappingProdList({rev_id:state.revSelect3.selected});

  if (res && res.rtn) { 
   savedMappingsV1RevId.value = res.rtn.parentRevisionId || '';
   savedMappingsV2RevId.value = res.rtn.childrenRevisionId || '';
   savedMappings.value = res.rtn.mappings || [];
  } else {
   savedMappingsV1RevId.value = '';
   savedMappingsV2RevId.value = '';
   savedMappings.value = [];
  }
  
   selectedSavedParentIds.value.clear();
};


const getSelectedSavedMappings = async() => {
       const selectedData = savedMappings.value.filter(item => 
           selectedSavedParentIds.value.has(item.parent.class_Id)
       );

       const result = {
           parentRevisionId: savedMappingsV1RevId.value,
           childrenRevisionId: savedMappingsV2RevId.value,
           mappings: selectedData
       };

       
       const res = await deleteMappingProd(result);
       if(res.code ==='0000'){
         toast.add({ severity: 'success', summary: '해제완료', detail: '맵핑해제가 완료되었습니다.', life: 3000 });
         state.revSelect.selected = savedMappingsV1RevId.value
         state.revSelect2.selected = savedMappingsV2RevId.value
         state.activeIndex = 0;
         state.revSelect3.selected = savedMappingsV1RevId.value;
         getSavedMappingsList();
       }else{
         toast.add({ severity: 'error', summary: '시스템 오류', detail: '매핑해제 중 오류가 발생했습니다.', life: 3000 });
       }
};

const getSelectedData = () => {
       if (selectedSavedParentIds.value.size === 0) {
           toast.add({ severity: 'warn', summary: '선택 필요', detail: '가져올 매핑 데이터를 하나 이상 선택해주세요.', life: 3000 });
           return;
       }
       getSelectedSavedMappings();
};


const mappingProdList = async () => {
  try {
  const payload = {
    parentRevisionId: state.revSelect.selected,
    childrenRevisionId: state.revSelect2.selected,
    mappings: Object.keys(mappings.value).map(key => ({
      parent: { class_Id: mappings.value[key].parent_class_id, class_nm: key }, 
      children: mappings.value[key].children.filter(child => child.class_id !== null),
    }))
  };
  
  if(payload.mappings.length === 0 ){
  toast.add({ severity: 'error', summary: '매핑 오류', detail: `저장할 매핑된 상품 목록이 없습니다. 상품을 맵핑해주세요.`, life: 3000 });
  } else if (!state.revSelect.selected || !state.revSelect2.selected) {
    toast.add({ severity: 'error', summary: '버전 선택 필요', detail: `매핑을 저장하려면 버전 1과 버전 2를 모두 선택해야 합니다.`, life: 3000 });
  } else {
  const res = await mappingProd(payload) 
    if(res.code === '0000'){
      toast.add({ severity: 'success', summary: '저장 완료', detail: '매핑된 항목들이 데이터베이스에 성공적으로 저장되었습니다.', life: 3000 });
      
      mappings.value = {};
      mappedVersion1Ids.value.clear();
      mappedVersion2Ids.value.clear();

      state.revSelect3.selected = state.revSelect.selected; 
      state.activeIndex = 2;
      getSavedMappingsList();
      
    } else {
      toast.add({ severity: 'error', summary: '저장 오류', detail: res.ex_message || '매핑 저장 중 알 수 없는 오류가 발생했습니다.'});
    }
  }
  
  } catch (err) {
  console.error("Error in mappingProdList:", err)
  toast.add({ severity: 'error', summary: '시스템 오류', detail: '매핑 저장 중 오류가 발생했습니다.', life: 3000 });
  } 
};


const rowClassV1 = (rowData) => {
if (mappedVersion1Ids.value.has(rowData.class_Id)) {
  return 'mapped-row-gray'; 
}
return null;
}
const rowClassV2 = (rowData) => {

if (mappedVersion2Ids.value.has(rowData.class_Id)) {
  return 'mapped-row-gray'; 
}
return null; 
};


const isRowSelectableV1 = (rowData) => {
return !mappedVersion1Ids.value.has(rowData.class_Id);
};

const isRowSelectableV2 = (rowData) => {
return !mappedVersion2Ids.value.has(rowData.class_Id);
};

const onRowClickV1 = (event) => {
if (mappedVersion1Ids.value.has(event.data.class_Id)) {

  toast.add({
  severity: 'warn', 
  summary: '선택 불가',
  detail: `"${event.data.class_nm}" 항목은 이미 매핑되어 선택할 수 없습니다.`,
  life: 3000 
  });
}
};

const onRowClickV2 = (event) => {
if (mappedVersion2Ids.value.has(event.data.class_Id)) {
  toast.add({
   severity: 'warn',
   summary: '선택 불가',
   detail: `"${event.data.class_nm}" 항목은 이미 매핑되어 선택할 수 없습니다.`,
   life: 3000
  });
}
};

</script>
 
<style scoped>
:deep(.mapped-row-gray) {
	background-color: #e0e0e0 !important;
	color: #333333 !important;
}

:deep(.p-datatable .p-datatable-tbody > tr.mapped-row-gray.p-highlight) {
	background-color: #d0d0d0 !important;
	color: #000000 !important;
}

:deep(.p-datatable-tbody > tr.mapped-row-gray:not(.p-state-highlight):hover) {
	background-color: #e0e0e0 !important; 
	color: #333333 !important;
}

:deep(.p-datatable-tbody > tr.mapped-row-gray.p-highlight:hover) {
	background-color: #d0d0d0 !important; 
	color: #000000 !important;
}


:deep(.p-datatable-tbody > tr[aria-selected="false"][aria-disabled="true"]) {
	cursor: default;
}
:deep(.p-datatable-tbody > tr .p-selection-column .p-checkbox[aria-disabled="true"]),
:deep(.p-datatable-tbody > tr .p-selection-column .p-radiobutton[aria-disabled="true"]) {
	cursor: default;
}

.cursor-pointer {
	cursor: pointer;
}

.mapping-container {
	padding: 20px;
}

.mapping-actions {
	margin-bottom: 20px;
}

.table-responsive {
	margin-bottom: 20px;
}

.result-table {
	width: 100%;
	border-collapse: collapse;
}

.result-table th,
.result-table td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

.arrow::before {
	content: '→';
	padding: 0 10px;
	font-weight: bold;
}

.sticky-header {
	position: sticky; 
	top: 0; 
	background-color: white; 
	padding: 10px 0; 
	border-bottom: 1px solid #eee; 
	z-index: 10; 
}


.panel-header-container {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
}

.panel-title {
	margin: 0; 
	font-size: 1.1rem;
}

:deep(.p-panel .p-panel-content) {
	padding: 0.5rem;
	min-height: 300px;
}
:deep(.p-panel .p-panel-header) {
	padding: 0.75rem 1rem;
}

.w-full {
	width: 100%;
}

.text-center {
	text-align: center;
}
.py-4 {
	padding-top: 1rem;
	padding-bottom: 1rem;
}
.text-end {
	text-align: right;
}

:deep(.p-tabview-nav-link) {
	font-weight: 600;
}

.result-table tbody tr td:first-child {
	vertical-align: top; 
}

.tab-header-wrapper {
	position: relative;
	position: sticky; 
	top: 0;
	z-index: 10;
	background-color: var(--surface-card, #ffffff);
}

.tab-header-wrapper :deep(.p-tabview) {
	flex-grow: 1; 
}

.mapping-execute-btn-final-absolute {
	position: absolute;
	top: 7px;
	right: 0;
	z-index: 11;
	height: 2.2rem;
}
</style>
